import React from 'react'
import { Check, Minus } from 'lucide-react'

export default function BooleanToggle({ value, onChange }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      title={value ? 'Enabled — click to disable' : 'Disabled — click to enable'}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        borderRadius: 6,
        border: 'none',
        cursor: 'pointer',
        backgroundColor: value ? '#dcfce7' : '#f3f4f6',
        color: value ? '#16a34a' : '#9ca3af',
        transition: 'background-color 0.15s, color 0.15s',
      }}
      onMouseEnter={(e) => {
        if (value) {
          e.currentTarget.style.backgroundColor = '#bbf7d0'
        } else {
          e.currentTarget.style.backgroundColor = '#e5e7eb'
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = value ? '#dcfce7' : '#f3f4f6'
      }}
    >
      {value ? <Check size={14} strokeWidth={3} /> : <Minus size={14} />}
    </button>
  )
}
